import React, { useEffect, useState } from "react";
import "./_harga.scss";
import check from "../../_assets/img/clipart/ic-check.png";
import CardPaket1 from "./CardPaket1";
import CardPaket2 from "./CardPaket2";
import CardPaket3 from "./CardPaket3";

function Harga() {
  const [cardPaket1, setCardPaket1] = useState(false);
  const [cardPaket2, setCardPaket2] = useState(false);
  const [cardPaket3, setCardPaket3] = useState(false);

  let popHarga = document.getElementById("bgHarga");
  console.log(popHarga);

  const handleCard1 = () => {
    setCardPaket1(true);
    popHarga.classList.add("opacity-25");
  };
  const handleCard2 = () => {
    setCardPaket2(true);
    popHarga.classList.add("opacity-25");
  };
  const handleCard3 = () => {
    setCardPaket3(true);
    popHarga.classList.add("opacity-25");
  };

  return (
    <section id="harga" className="pt-10 relative">
      {cardPaket1 ? (
        <CardPaket1 setCardPaket1={setCardPaket1} popHarga={popHarga} />
      ) : null}
      {cardPaket2 ? (
        <CardPaket2 setCardPaket2={setCardPaket2} popHarga={popHarga} />
      ) : null}
      {cardPaket3 ? (
        <CardPaket3 setCardPaket3={setCardPaket3} popHarga={popHarga} />
      ) : null}
      <div className="container" id="bgHarga">
        <div className="row justify-content-center">
          <div
            className="col-12 col-lg-7"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            <h1 className="text-center">
              Berapa harga undangan di UndangResepsi ?
            </h1>
            <p>
              Harga yang sangat terjangakau dan ada banyak bonus yang kamu
              dapatkan
            </p>
          </div>
        </div>
        <div className="row">
          <div
            className="col-12 col-md-6 col-lg-4"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            <div className="card">
              <div className="card-body">
                <h4>UR 1</h4>
                <h2>Rp.60.000</h2>
                <ul>
                  <li>
                    <img src={check} alt="" />
                    Undangan Video Wedding
                  </li>
                  <li>
                    <img src={check} alt="" />
                    Wedding Letter Card
                  </li>
                  <li>
                    <img src={check} alt="" />
                    Wedding Save The Date
                  </li>
                </ul>
                <button onClick={handleCard1} className="btn">
                  Pilih Paket
                </button>
              </div>
            </div>
          </div>

          <div
            className="col-12 col-md-6 col-lg-4"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            <div className="card card-highlight">
              <div className="card-body">
                <h4>UR 2</h4>
                <h2>Rp.70.000</h2>
                <ul className="mx-auto">
                  <li>
                    <img src={check} alt="" />
                    Undangan Video Wedding
                  </li>
                  <li>
                    <img src={check} alt="" />
                    Wedding Letter Card
                  </li>
                  <li>
                    <img src={check} alt="" />
                    Wedding Save The Date
                  </li>
                  <li>
                    <img src={check} alt="" />
                    Wedding Envelopes
                  </li>
                </ul>
                <button onClick={handleCard2} className="btn">
                  Pilih Paket
                </button>
              </div>
            </div>
          </div>

          <div
            className="col-12 col-md-6 col-lg-4"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            <div className="card">
              <div className="card-body">
                <h4>UR 3</h4>
                <h2>Rp.90.000</h2>
                <ul className="list-Benefit">
                  <li>
                    <img src={check} alt="" />
                    Undangan Video Wedding
                  </li>
                  <li>
                    <img src={check} alt="" />
                    Wedding Letter Card
                  </li>
                  <li>
                    <img src={check} alt="" />
                    Wedding Save The Date
                  </li>
                  <li>
                    <img src={check} alt="" />
                    Wedding Envelopes
                  </li>
                  <li>
                    <img src={check} alt="" />
                    Moodboard video moment
                  </li>
                </ul>
                <button onClick={handleCard3} className="btn">
                  Pilih Paket
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Harga;
